import { Dialog, useDialog } from "@fpsoftware/mvp";
import { zodResolver } from "@hookform/resolvers/zod";
import { LocalDate } from "@js-joda/core";
import { useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { TbDeviceFloppy } from "react-icons/tb";
import { AddressUpdateTaxBodySchema } from "shared";
import { useSuspenseAddress } from "@/addresses/hooks";
import { Api } from "@/api.config";
import { Button } from "@/components/Button";
import { NumberInput } from "@/components/form/NumberInput";
import { TextField } from "@/components/form/TextField";
import { QueryKeys } from "@/LinkGen";
import { invalidateMortgagesWithAddressID } from "@/mortgages/hooks";

export const UpdateAddressTaxDialog = (props: { addressID: number }) => {
  const address = useSuspenseAddress(props.addressID);
  const dialog = useDialog();

  const { handleSubmit, formState, control } = useForm({
    resolver: zodResolver(AddressUpdateTaxBodySchema),
    defaultValues: {
      amount: Number(address.taxes?.amount ?? 0),
      year: address.taxes?.year ?? LocalDate.now().year(),
    },
  });
  const queryClient = useQueryClient();

  const onSubmit = handleSubmit(async (values) => {
    await Api.AddressUpdateTax(props.addressID, values);
    await queryClient.refetchQueries({
      queryKey: QueryKeys.Address(props.addressID),
    });
    await invalidateMortgagesWithAddressID(queryClient, props.addressID);
    dialog.close();
  });

  return (
    <form onSubmit={onSubmit}>
      <Dialog.Header>Update address tax</Dialog.Header>
      <Dialog.Body>
        <NumberInput
          label="Annual tax"
          placeholder="4321.12"
          autoFocus
          control={control}
          name="amount"
          required
        />
        <TextField
          label="Tax year"
          placeholder="2020"
          control={control}
          required
          name="year"
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Button
          icon={TbDeviceFloppy}
          type="submit"
          loading={formState.isSubmitting}
        >
          Save
        </Button>
      </Dialog.Footer>
    </form>
  );
};
